import React from 'react'
import { Drawer, Descriptions, Divider, Space, Button, Tag, Typography, Avatar } from 'antd'
import { EditOutlined, DeleteOutlined, PictureOutlined } from '@ant-design/icons'
import type { Category } from '../types/category.types'
import { DocumentAvatar } from '../../../shared/components/DocumentAvatar'

const { Text } = Typography

interface CategoryDetailsDrawerProps {
    open: boolean
    onClose: () => void
    category: Category | null
    onEdit: (category: Category) => void
    onDelete: (category: Category) => void
}

export const CategoryDetailsDrawer: React.FC<CategoryDetailsDrawerProps> = ({
    open,
    onClose,
    category,
    onEdit,
    onDelete
}) => {
    if (!category) return null

    return (
        <Drawer
            title="Category Details"
            placement="right"
            width={600}
            onClose={onClose}
            open={open}
        >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <div style={{ textAlign: 'center' }}>
                    {category.imageId ? (
                        <DocumentAvatar documentId={category.imageId} size={120} shape="square" />
                    ) : category.image ? (
                        <Avatar src={category.image} size={120} shape="square" />
                    ) : (
                        <Avatar
                            size={120}
                            shape="square"
                            icon={<PictureOutlined />}
                            style={{ backgroundColor: '#f0f0f0', color: '#999' }}
                        />
                    )}
                </div>


                <Descriptions title="Category Information" column={1} bordered>
                    <Descriptions.Item label="Category Name">
                        <Text strong>{category.name}</Text>
                    </Descriptions.Item>
                    <Descriptions.Item label="Slug">
                        <Tag>{category.slug}</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Parent Category">
                        {category.parentCategory || <Tag color="blue">Root Category</Tag>}
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                        {category.description}
                    </Descriptions.Item>
                    <Descriptions.Item label="Products">
                        <Tag color="purple">{category.productCount} products</Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                        <Tag color={category.status === 'active' ? 'green' : 'gray'}>
                            {(category.status || 'inactive').toUpperCase()}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Created">{category.createdAt}</Descriptions.Item>
                </Descriptions>

                <Divider />

                <Space>
                    <Button type="primary" icon={<EditOutlined />} onClick={() => onEdit(category)}>
                        Edit Category
                    </Button>
                    <Button danger icon={<DeleteOutlined />} onClick={() => onDelete(category)}>
                        Delete Category
                    </Button>
                </Space>
            </Space>
        </Drawer>
    )
}
